
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { ServiceBase } from '@app/services/base.service';
import { Banco } from '@app/models/banco.model';

@Injectable()
export class BancoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  gravar(banco: Banco): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'configuracoes/banco', banco).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `configuracoes/banco/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/banco/${id}`, { headers: { meta: ['search'] }});
  }

  obterLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `configuracoes/banco/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

}
